/* eslint-disable */
import BaseService from "../../BaseService";

const { http, axios, buildHeaders, buildEndpoint } = BaseService();

// API
//////////////////////////////////////////////////////////////////

export function GetPagingParams(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params",
    method: "post",
    data,
  });
}

export function GetCanBoCongChucDaXoa(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params-deleted",
    method: "post",
    data,
  });
}
export function GetCanBoCongChucKhoiDang(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params-khoi-dang",
    method: "post",
    data,
  });
}
export function GetCanBoCongChucNghiViec(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params-nghi-viec",
    method: "post",
    data,
  });
}

export function GetPagingParamsSync(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params-sync-failed",
    method: "post",
    data,
  });
}

export function CanBoCongChucTraCuu(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/get-paging-params-tra-cuu",
    method: "post",
    data,
  });
}

export function CanBoCongChucGetAllOfCanBo(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/getAll",
    method: "get",
    data,
  });
}

export function CanBoCongChucGetByIddv(id) {
  return http({
    url: "CanBoCongChuc/get-cbcc-by-iddv/" + id,
    method: "get",
  });
}

export function CanBoCongChucGetInfo(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/GetInfo",
    method: "post",
    data,
  });
}

export function GetInfoExport(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/GetInfoExport",
    method: "post",
    data,
  });
}

export function GetInfoByUsername(postdata) {
  return http({
    url: "CanBoCongChuc/get-by-email/" + postdata,
    method: "get",
  });
}

export function CanBoCongChucCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/Create",
    method: "post",
    data,
  });
}

export function CanBoCongChucUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/update",
    method: "post",
    data,
  });
}

export function CanBoCongChucDelete(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/Delete",
    method: "post",
    data,
  });
}

export function UpdateThongTinChung(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/updateThongTinChung",
    method: "post",
    data,
  });
}

export function UpdateThongTinKhac(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/updateThongTinKhac",
    method: "post",
    data,
  });
}

export function UpdateBienCheHopDong(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/UpdateBienCheHopDong",
    method: "post",
    data,
  });
}

export function UpdateLuong(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/UpdateLuong",
    method: "post",
    data,
  });
}

export function UpdateDaoTaoBoiDuong(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/UpdateDaoTaoBoiDuong",
    method: "post",
    data,
  });
}

export function UpdateLichSuBanThan(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/updateLichSuBanThan",
    method: "post",
    data,
  });
}
export function UpdateNhanXetDanhGia(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/updateNhanXetDanhGia",
    method: "post",
    data,
  });
}

export function UpdateThuNhapVaDatSanXuat(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/UpdateThuNhapVaDatSanXuat",
    method: "post",
    data,
  });
}

export function CanBoCongChucCreateNghiViec(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/CreateNghiViec",
    method: "post",
    data,
  });
}
export function CanBoCongChucCreateKhoiDang(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/CreateKhoiDang",
    method: "post",
    data,
  });
}

export function CanBoCongChucUpdateNghiViec(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/UpdateNghiViec",
    method: "post",
    data,
  });
}

export function CanBoCongChucDeleteKhoiDang(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/DeleteKhoiDang",
    method: "post",
    data,
  });
}

export function CanBoCongChucKhoiPhucDelete(postdata) {
  const data = { ...postdata };
  return http({
    url: "CanBoCongChuc/KhoiPhucDeleted",
    method: "post",
    data,
  });
}

export function ResetAvatarUser(id) {
  return http({
    url: "CanBoCongChuc/reset-avatar/" + id,
    method: "get",
  });
}
